import React from 'react'
import './headerBlog.css';

function HeaderBlog2() {
  return (
      <section id='home' className='section_headerBlog'>
        <div className='container headerBlog_main'>
          {/* <h1>Blog</h1> */}

           <div className='col-lg-6 col-md-12 col-sm-12 headerBlog_wrapper'>
                <div className='headerBlogPage_info'>Published on: Feb 21, 2025</div>
          <p className='headerBlogPage_info'>Author: Ponos Technology</p>
          <h2 className='headerBlogPage_title'>Ponos Technology’s <span className='nowrap'>HW-Accelerated</span> Plonky2 GoldiBear: Unleashing Plonky2 Over BabyBear Throughput</h2>

           </div>
         
        </div>
    </section>
  )
}

export default HeaderBlog2
